<template><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12">
	<polygon class="bright" points="6,1 2,6 5,6 5,11 7,11 7,6 10,6" />
</svg>
</template>